import { render, staticRenderFns } from "./Dima.vue?vue&type=template&id=391f39e8&"
import script from "./Dima.vue?vue&type=script&lang=js&"
export * from "./Dima.vue?vue&type=script&lang=js&"
import style0 from "./Dima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports